<div class="settings-div" [hidden]="!showCalendar">
	<div class="options-padding">
		<div class="option">
			<app-breadcrumb-anchor label="Change Password" event="change-password"></app-breadcrumb-anchor>
		</div>
		<div class="option">
			<app-breadcrumb-anchor label="Log Out" event="logout"></app-breadcrumb-anchor>
		</div>
	</div>
</div>
